import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronWideOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m22.995 13.442-.91 1.554L12 9.083 1.915 14.996l-.91-1.554L12 6.997z" fill="currentColor" />
        </g>
    </svg>
));
ChevronWideOutlinedSize24Glyph.displayName = 'ChevronWideOutlinedSize24Glyph';
